import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { AuthPost, AuthGet, AuthPut } from "../../_common/httpService";
import {validateVertical} from "../../_common/Validation";
import Stepper from "../../Components/Stepper";
import HomeImprovement from "../../assets/slices/home_improvement.svg";
import Personalloans from "../../assets/slices/product_icon2.svg";
import SmbLoans from "../../assets/slices/smb_loan.svg";
import PersonalCare from "../../assets/slices/personal_care.svg";
import rightDirection from "../../assets/slices/next_direction.svg";
import AutoLoanIcon from "../../assets/slices/autoLoan_icon.svg";
import BnplLoanIcon from "../../assets/slices/bnplLoan_icon.svg";
import ISALoanIcon from "../../assets/slices/isa icon.svg";
import Toast from "../../Components/Toast";
import { toast } from "react-hot-toast";
import brandlogo from "../../assets/images/brand_logo.svg";
import UserAvatar from "../../Components/UserAvatar/UserAvatar";

const Vertical = () => {
  const [verticals, setVerticals] = useState([]);
  const [SMB, ISA, BNPL] = ["SMB loan", "ISA", "BNPL"];
  const navigate = useNavigate();
  const tenantId = sessionStorage.getItem("tenantId");
  const businessName = sessionStorage.getItem("businessName");
  const subscriptionId = sessionStorage.getItem("subscriptionId");
  const verticalID = sessionStorage.getItem("VerticalId");
  const addNewSubscription = JSON.parse(sessionStorage.getItem("newSubscription"));

  const dropdownRef = useRef(null); 
  const [isOpen, setIsOpen] = useState(false); 

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); 
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getVerticals = async () => {
    try {
      const res = await AuthGet(addNewSubscription ? `vertical/list/${tenantId}` : "vertical/list/all");
      if (res.statusCode === 200) {
        res.data.tenants.map((verts, ind) => {
          if (verticalID) {
            if (verts?.id === verticalID) {
              setValues({ verticalId: verts?.id, businessName: businessName ? businessName : "" });
            }
          }
          setVerticals(res.data.tenants);
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    getVerticals();
  }, []);

  const { touched, errors, handleSubmit, values, handleChange, handleBlur, setValues,setFieldValue } = useFormik({
    initialValues: {
      businessName: businessName ? businessName : "",
      verticalId: verticalID ? verticalID : "",
      verticalName: "",
    },
    enableReinitialize: true,
    validate: validateVertical,
    onSubmit: async (values) => {
      if (!values.verticalId) {
        toast.error("Please select a vertical");
        return;
      }
      console.log('values::: ', values);
      // values?.preventDefault();
      sessionStorage.setItem("businessName", values.businessName);
      if (values.verticalName === BNPL || values.verticalName === ISA) {
        sessionStorage.setItem("VerticalId", values.verticalId);
        navigate(`/contactform`);
        return;
      }

      const subParams = {
        subscriptions: [
          {
            verticalId: values.verticalId,
            tenantId: tenantId,
            businessName: values.businessName,
            subscriptionId: subscriptionId ? subscriptionId : null,
          },
        ],
      };

      let data = {
        allTenants: [
          {
            tenantId: tenantId,
            businessName: values.businessName,
          },
        ],
      };
      sessionStorage.setItem("VerticalId", values.verticalId);
      await AuthPost("subscription/create", subParams).then((res) => {
        console.log('res::: ', res);
        if (res.statusCode === 200) {
          sessionStorage.setItem("subscriptionId", res.data);
          sessionStorage.setItem("selectedthemeid", "39c475c7-974a-4c5b-803f-9938e3dd4d33");
          sessionStorage.setItem("themename", "style1");

          toast.success(res.message);
          AuthPut("tenantmaster/update", data)
            .then(async (res) => {
              if (res.statusCode === 200) {
                AuthGet(`subproduct/list/${values.verticalId}`)
                  .then((resp) => {
                    if (resp.statusCode === 200) {
                      sessionStorage.setItem("ProductId", resp.data.subProducts[0].id);
                      sessionStorage.setItem("selectedVertical", resp.data.subProducts[0].name);

                      const subParams = {
                        subscriptions: [
                          {
                            productId: resp.data.subProducts[0].id,
                            tenantId,
                            verticalId: values.verticalId,
                          },
                        ],
                      };

                      AuthPut("subscription/update/" + sessionStorage.getItem("subscriptionId"), subParams).then(
                        (respon) => {
                          if (resp.name === "Business loan" && respon.statusCode === 200) {
                            navigate("/change-password");
                          } else if (resp.name !== "Business loan" && respon.statusCode === 200) {
                            navigate("/upload-logo");
                          }
                        }
                      ).catch((err) => {});
                    }
                  }).catch((err) => {});
              }
            })
            
        }else {
          toast.error("BusinessName Already Exist");
        }
      }).catch((err) => {
        const errObj = JSON.parse(err.message);
        toast.error(errObj.data.message);
      });
    },
  });

  // Get selected vertical
  let updateChange = (e, value) => {
    e?.preventDefault();
    if (value?.is_subscribed) {
    } else {
      setValues({ verticalId: value?.id, verticalName: value.name, businessName: businessName ? businessName : values.businessName });
    }
  };

  return (
    // <div className="fullScreen_bg p0">
    <>
      <Toast />
      <div className="topHeader">
          <div>
            <div className="brand_logo">
              <img src={brandlogo} alt="brand_logo" />
            </div>
          </div>
              <Stepper />
          <div>
            {addNewSubscription === true ? (
              <UserAvatar logout={true} quickGuide={true} business={true} changePassword={true} profile={true} />
            ) : (
              <UserAvatar logout={true} />
            )}
          </div>
      </div>

      {/* <div className="full_header"> */}
        {/* <div className="pagecontentblock"> */}
          {/* <div className="Customerpanel_rectangle border_radius0 box_shadow_none"> */}
            <div className="p40">
              {businessName && !addNewSubscription ? (
                <h3 className="textAlign_center mb_40 HorrorSnob_Color headingTitle28">{businessName}</h3>
              ) : (
                <></>
              )}

              <form onSubmit={handleSubmit}>
                {addNewSubscription ? (
            <div className="businessInputSticky">
                  <div className="mb_24 row pzero justifyContent_center">
                    <div className="col-md-5">
                  <div className="businessInputFrame">
                    <div>
                    <label className="fontSize20 fontWeight_500  blackText">Business Name</label>
                      </div>
                      <div>
                        <input className="adminInput"
                          type="text"
                          id="business_name"
                          name="businessName"
                          placeholder="Enter your business name"
                          onChange={(e) => {
                            let value = e.target.value;
                            // Remove special characters and spaces (only allow letters and numbers)
                            value = value.replace(/[^a-zA-Z0-9]/g, "");
  
                            // Ensure the first character is a letter
                            if (!/^[a-zA-Z]/.test(value)) {
                              value = value.replace(/^[^a-zA-Z]+/, ""); // Remove any leading non-letter characters
                            }
                            // // Match first character as a number followed by only letters and spaces
  
                            setFieldValue("businessName", value);
                          }}
                          value={values.businessName}
                          onBlur={handleBlur}
                        />
                      </div>
                  </div>
                      {errors.businessName && touched.businessName ? <div className="VermilionBirdText fontSize12 fontWeight_500 mt_8">{errors.businessName}</div> : null}
                  </div>
                  </div>
            </div>
                ) : null}

                <h5 className="textAlign_center  blackText fontSize24 fontWeight_600">
                  Choose an option below to know more about you
                </h5>
                <p className="textAlign_center fontSize16 fontWeight_400  blackText mb_24">This will help us to give you a tailored experience</p>

                {errors.verticalId && touched.verticalId ? <div className="error_text">{errors.verticalId}</div> : null}

                <div ref={dropdownRef} className="row pzero">
                  {verticals.map((vertical, i) => {
                    return (
                      <div
                        className="col-md-3 mb_24"
                        key={i}
                        style={vertical?.is_subscribed ? { opacity: 0.5 } : { opacity: 1 }}
                      >
                        <label
                          htmlFor="verticalId"
                          className={`vertical_item_noHover ${values.verticalId === vertical.id ? `seleted` : ""}`}
                          onClick={(e) => updateChange(e, vertical)}
                        >
            

                                <div className="mediaObject_body">
                                  <input
                                    type="radio"
                                    name="verticalId"
                                    value={values.verticalId}
                                    style={{ display: "none" }}
                                    onBlur={handleBlur}
                                  />
                                   <h6>{vertical?.name === "Personal care" ? "Health Care" : vertical?.name}</h6>
                                  <p className="mb_0">
                                    {vertical?.description}
                                  </p>
                                </div>
                          <div className="vertical_icon">
                            {vertical.name === "Personal care" ? (
                              <img src={PersonalCare} alt={"Vertical_Icon"} />
                            ) : vertical.name === "SMB loan" ? (
                              <img src={SmbLoans} alt={"Vertical_Icon"} />
                            ) : vertical.name === "Personal Loan" ? (
                              <img src={Personalloans} alt={"Personalloans"} />
                            ) : vertical.name === "Home Improvement" ? (
                              <img src={HomeImprovement} alt={"Vertical_Icon"} />
                            ) : vertical.name === "Auto Loan" ? (
                              <img src={AutoLoanIcon} alt={"Vertical_Icon"} />
                            ) : vertical.name === "BNPL" ? (
                              <img src={BnplLoanIcon} alt={"Vertical_Icon"} />
                            ) : vertical.name === "ISA" ? (
                              <img src={ISALoanIcon} alt={"Vertical_Icon"} />
                            ) : null}
                          </div>
                        </label>
                      </div>
                    );
                  })}
                </div>

                <div className="textAlign_center">
                  <button type="submit" className="Mainbutton  ">
                    Continue
                  </button>
                </div>
              </form>
            </div>
          {/* </div> */}
        {/* </div> */}
      {/* </div> */}
    </>
    // </div>
  
  );
};

export default Vertical;
